import whenNoRunningUiLessAddinOnHostItem from './utils/UiLessObserver';
import { closeNonPersistentTaskPaneAddinCommand } from 'owa-addins-view';
import { deleteAdapter, destroyExtensibilityNotifications } from 'owa-addins-apis';
import { destroyExtensibilityHostItem, isHostItemActive } from 'owa-addins-store';

export default function deinitializeAddinsForItem(hostItemIndex: string) {
    destroyExtensibilityNotifications(hostItemIndex);
    closeNonPersistentTaskPaneAddinCommand(hostItemIndex);
    destroyExtensibilityHostItem(hostItemIndex);
    whenNoRunningUiLessAddinOnHostItem(hostItemIndex, deinitializeAddinsForNonActiveHostItem);
}

function deinitializeAddinsForNonActiveHostItem(hostItemIndex: string) {
    if (isHostItemActive(hostItemIndex)) {
        return;
    }

    deleteAdapter(hostItemIndex);
}
